import styled, { css } from 'styled-components';
import { COLORS } from 'config/theme';

export const Th = styled.div`
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OrderIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 3px;

  img {
    width: 9px;
    transform: rotate(-180deg);
    transition: 0.25s all;

    ${props => props.ascending && css`
      transform: rotate(0);
    `}
  }
`;

export const styles = {
  tableFixed: {
    tableLayout: 'fixed',
  },
  tableHeadTr: {
    height: 'auto',
    position: 'relative',
    lineHeight: 1,
  },
  tableBodyTr: {

  },
  sortingActive: {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  tableTh: {
    padding: 0,
    backgroundColor: 'rgba(31, 38, 107, 0.1)',
    fontFamily: 'Cairo',
    fontSize: 13,
    letterSpacing: 2,
    textAlign: 'center',
    color: COLORS.primaryColor,
    fontWeight: 700,
    textTransform: 'uppercase',
    border: 0,
  },
  tableTd: {
    height: 56,
    padding: 0,
    position: 'relative',
    fontFamily: 'Cairo',
    fontSize: 14,
    letterSpacing: 0.4,
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.84)',
    wordWrap: 'break-word',
  },
};



// WEBPACK FOOTER //
// ./src/components/IterioApp/components/TableApp/styles.js